import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text } from './base/index';
import GlossaryTerm from './GlossaryTerm';
import useGlossaryHandler from '../hooks/useGlossaryHandler';
import { debugLog } from '../utils/index';

const GlossaryTerms = ({ glossaryIds }) => {
  const { isValidTermId } = useGlossaryHandler();
  debugLog('glossaryIds', glossaryIds);
  // Compute validGlossaryIds using useMemo
  const validGlossaryIds = useMemo(() => {
    return glossaryIds.filter((termId) => isValidTermId(termId));
  }, [glossaryIds, isValidTermId]);

  // If no valid glossary terms, render nothing
  if (validGlossaryIds.length === 0) {
    return null;
  }

  return (
    <>
      <Text
        tag="label"
        className="mt-6 text-blue-accent mb-4 break-after-avoid"
      >
        Glossary Definitions
      </Text>
      {validGlossaryIds.map((termId) => (
        <GlossaryTerm key={termId} termId={termId} />
      ))}
    </>
  );
};

GlossaryTerms.propTypes = {
  glossaryIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default GlossaryTerms;